<template>
  <div class="p-0">
    <!-- TODO: allow to append message -->

    <div v-if="receiver" class="d-flex">

      <span
        class="avatar m-3 align-self-center"
        :style="{
          backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(receiver.profilePic) + '&quot;)'
        }" />
      <span class="m-3 align-self-center">{{receiver.displayName}}</span>

    </div>
    <div v-else>

      <!-- optionally show user selection -->
      <user-selector
        class="m-2"
        @select="onUserHandleSelect" />

    </div>

    <!-- <user-mini-avatar :user-id="contactId" :show-name="true" size="32" /> -->

    <task-selector v-model="current_task" :read-only="dragData.taskId != null" />

    <el-input
      type="textarea"
      v-model="config.message"
      @input="onUpdate"
      placeholder="Type message..." />

    <template v-if="onlyCopyAllowed">
      <p>User is not member of this goal. You can only send a copy of this task.</p>
      <el-checkbox class="p-2" :value="true" disabled>
        Send copy of this task
      </el-checkbox>
    </template>
    <template v-else>
      <el-checkbox
        class="p-2"
        v-model="config.copy">
        Send copy of this task
      </el-checkbox>
    </template>

    <!-- TODO: more options see screenshot -->
    <!-- TODO: allow to set deadline etc. -->

    <!--
    <pre class="mini-pre">{{current_task}}</pre>
    <pre class="mini-pre">{{dragData}}</pre>
    <pre class="mini-pre">{{value}}</pre>
    <pre class="mini-pre">{{config}}</pre>
    <pre class="mini-pre">{{contactId}}</pre>
    -->
  </div>
</template>

<script>
import TaskSelector from '@/components/RoutineCreatorPage/Elements/TaskSelector'

export default {
  props: {
    contactId: {},
    dragData: {},
    onlyCopyAllowed: {},
    value: { type: Object },
  },
  data() {
    return {
      config: {}
    };
  },
  watch: {
    contactId(id) {
      this.config.receiverUserId = id;
    },
  },
  created() {
    this.reset();
    this.onUpdate();
  },
  computed: {
    configSanitized() {
      let config = { ...this.config }
      if ( this.onlyCopyAllowed ) {
        config.copy = true;
      }
      return config;
    },
    receiver() {
      if ( this.config.receiverUserId ) {
        return this.$models.userContact.get_contact_by_id( this.config.receiverUserId );
      }
      return null
    },
    current_task: {
      get() {
        return this.config.task || this.dragData;
      },
      set( value ) {
        this.config.task = value;
        this.$emit('input', this.configSanitized)
      }
    }
  },
  methods: {
    reset( keepMessage = false ) {
      // TODO: Reset message, when user has changed?
      let message = keepMessage ? ( this.config.message || '' ) : '';
      this.config = {
        message: message,
        receiverUserId: this.contactId || null,
        task: null,
        copy: false,
      }
    },
    onUpdate() {
      this.$emit('input', this.configSanitized)
    },
    onUserHandleSelect(selection) {
      console.log("onUserHandleSelect", selection);
      this.config.receiverUserId = selection.id;
      this.onUpdate();
    },
  },
  components: {
    TaskSelector
  }
};
</script>
